import { render, staticRenderFns } from "./PasswordSettings.vue?vue&type=template&id=20ce2308&"
import script from "./PasswordSettings.vue?vue&type=script&lang=ts&"
export * from "./PasswordSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports